
import React from 'react'
import { Navigate } from 'react-router-dom';
import { checkAuth } from './auth';
import DefaultLayout from '../../containers'; // 直接导入

const ProtectedRoute = () => {
  return checkAuth() ? <DefaultLayout /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;